import React from 'react';
import styled from 'styled-components';
import MsxIcons from '../features/msx-icons';

const StyledButton = styled.button`
  background-color: #FAFAFA;
  border: none;
  color: #42B4E6;
  font-weight: bold;
  border-radius: 2px;
  padding: 10px 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;

  ${props => props.disabled ? 'opacity: 0.5;pointer-events:none;' : ''}
`;

const IconWrapper = styled.div`
margin-right: 10px;
`;

const CustomButton = ({ children, onClick, disabled }) => (
  <StyledButton disabled={disabled} onClick={onClick} id='CustomButton'>
    <IconWrapper>
    <MsxIcons name="add"></MsxIcons>
    </IconWrapper>
    {children}
  </StyledButton>
);

export default CustomButton;